import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const value = ref(0)

const reload = () => {
  value.value++
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, {
    key: [_ctx.$route.fullPath, value.value],
    onOnRouterViewReload: reload
  }))
}
}

})